import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
    },
    title: {
      color: COLORS.gray.gray40,
      marginBottom: theme.spacing(0.5),
    },
    variables: {
      display: 'flex',
      gap: theme.spacing(0.5),
      flexWrap: 'wrap',
    },
    tooltip: {
      maxHeight: 354,
      textOverflow: 'hidden',
      display: '-webkit-box',
      '-webkit-line-clamp': 17,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
    },
    button: {
      color: COLORS.gray.black,
      padding: theme.spacing(0.75),
      border: theme.shape.borderGray70,
      backgroundColor: COLORS.gray.white,
      minWidth: 'unset',
      fontWeight: theme.typography.fontWeightRegular,
      '& span': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
  }),
  { name: 'Variables' }
);
